import { format } from "date-fns";
import { useEffect, useState } from "react";
import { DataGrid } from "../../../components";
import { PermisoesHelper } from "../../../helpers";
import { ListLayout } from "../../../layouts";
import { history, MdfeService, notification } from "../../../services";
import { formatDate, responseErros } from "../../../utils";
import { FormFiltroAvancado } from "./components";
import { obterIconeStatus } from "./list-mdfe";

const ListMdfeView = () => {
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("mdfe-visualizar");
  const [loading, setLoading] = useState(false);
  const [rowCount, setRowCount] = useState(null);
  const [mdfe, setMdfe] = useState([]);
  const mdfeService = new MdfeService();
  const status = [
    {
      id: 1,
      nome: "Enviada",
      cor: "#4FBB53",
    },
    {
      id: 2,
      nome: "Pendente",
      cor: "#EA9D2B",
    },
    {
      id: 3,
      nome: "Cancelada",
      cor: "#DC3545",
    },
    {
      id: 4,
      nome: "Encerrada",
      cor: "#004780",
    },
  ];
  const colunas = [
    {
      field: "status",
      headerName: "Status",
      flex: 100,
      filtrar: true,
      renderCell: (params) => obterIconeStatus(params.value),
    },
    {
      field: "numeroDocumento",
      headerName: "Nº Documento",
      flex: 150,
      filtrar: true,
    },
    {
      field: "serieDocumento",
      headerName: "Série",
      flex: 150,
    },
    {
      field: "createdAt",
      headerName: "Data de Lançamento",
      flex: 200,
      valueGetter: (params) =>
        format(formatDate.received(params.value), "dd/MM/yyyy"),
    },
  ];

  useEffect(() => {
    buscarMdfe();
  }, []);

  const buscarMdfe = async function (filter) {
    setLoading(true);
    const result = await mdfeService.getAll(filter);
    if (!result.isAxiosError) {
      setRowCount(result.data.count);
      setMdfe(result.data.rows);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const onClickCadastrarMdfe = function () {
    history.push("/faturamento/mdfe/create");
  };

  const onClickEditMdfe = function (id) {
    history.push(`/faturamento/mdfe/${id}`);
  };

  const onClickDeleteMdfe = async function (id) {
    const data = mdfe.find((item) => item.id === id);
    if (data.status == "ENVIADA" || data.status == "CANCELADA") {
      notification.alertaGenericos(
        "Só é permitido excluir MDFE que se encontram Pendente."
      );
      return;
    }
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      `Tem certeza que deseja excluir ${data.numeroDocumento}`
    );
    if (retornoAlerta.isConfirmed) {
      setLoading(true);
      const result = await mdfeService.deletar(id);
      if (!result.isAxiosError) {
        buscarMdfe();
        notification.deletadoSucesso();
      } else {
        setLoading(false);
        responseErros(result);
      }
    }
  };

  const buscarPesquisaAvancada = async (filter) => {
    const filtrosAvancadosTemp = {
      ...filter,
      porIntervalo: [],
    };
    if (
      filtrosAvancadosTemp.dataLancamentoStart &&
      filtrosAvancadosTemp.dataLancamentoEnd
    ) {
      filtrosAvancadosTemp.porIntervalo.push({
        coluna: "createdAt",
        de: filtrosAvancadosTemp.dataLancamentoStart,
        ate: filtrosAvancadosTemp.dataLancamentoEnd,
      });
    }
    const result = await mdfeService.getAllFiltroAvancado({
      ...filtrosAvancadosTemp,
      restritiva: true,
    });
    if (!result.isAxiosError) {
      setMdfe(result.data.rows);
    } else {
      responseErros(result);
    }
  };

  const sendServerDatagrid = (props) => {
    if (props.tipoFiltro == "simples") {
      buscarMdfe(props.filtros);
    } else {
      buscarPesquisaAvancada(props.filtros);
    }
  };

  return (
    <ListLayout
      title="MDFE"
      loading={loading}
      onClickCadastrar={onClickCadastrarMdfe}
      permissaoButton={permissoesHelper.temPermisao("mdfe-cadastrar")}
      listaStatus={status}
    >
      <DataGrid
        rows={mdfe}
        columns={colunas}
        rowCount={rowCount}
        onClickEdit={onClickEditMdfe}
        onClickDelete={onClickDeleteMdfe}
        paginationMode={"server"}
        sendServer={(props) => sendServerDatagrid(props)}
        FormFiltroAvancado={FormFiltroAvancado}
        visualizarShow={permissoesHelper.temPermisao("mdfe-visualizar")}
        editShow={permissoesHelper.temPermisao("mdfe-editar")}
        deleteShow={permissoesHelper.temPermisao("mdfe-excluir")}
      />
    </ListLayout>
  );
};

export default ListMdfeView;
